import { render } from "./CalendarInput.vue?vue&type=template&id=3823f0b3&ts=true"
import script from "./CalendarInput.vue?vue&type=script&lang=ts"
export * from "./CalendarInput.vue?vue&type=script&lang=ts"

import "./CalendarInput.vue?vue&type=style&index=0&id=3823f0b3&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__